import { render, staticRenderFns } from "./docPortal.vue?vue&type=template&id=63ab78b6&scoped=true&"
import script from "./docPortal.vue?vue&type=script&lang=js&"
export * from "./docPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ab78b6",
  null
  
)

export default component.exports